import React from "react";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import TuneIcon from "@mui/icons-material/Tune";
import css from "./cpSourcingMobile.module.css";
import "./tokens.css";

// Search field and filter icon on one line, matching the Partners mobile
// toolbar. Owns no filter state — it renders values and raises events, so the
// pending/applied model each call site already has stays exactly as it is.
//
// Everything is pinned to px: App.css drops the root font-size to 7px below
// 767px, so rem-sized controls would render ~30% small here. The 16px input in
// particular also stops iOS Safari zooming the page when the field takes focus.
const SEARCH_SX = {
  "& .MuiOutlinedInput-root": {
    background: "#ffffff",
    borderRadius: "10px",
    minHeight: 44,
    fontFamily: "Inter-Medium",
    "& fieldset": { borderColor: "#d0d5dd" },
  },
  "& input": {
    fontSize: "16px",
    padding: "11px 14px 11px 0",
    lineHeight: "22px",
  },
  "& input::placeholder": { fontSize: "15px", color: "#98a2b3", opacity: 1 },
};

export default function MobileFilterBar({
  searchValue,
  onSearchChange,
  searchPlaceholder = "Search",
  // Count of *applied* selections, so the badge reflects what the list is
  // actually filtered by rather than what is merely ticked in the sheet.
  filterCount = 0,
  onOpenFilters,
}) {
  return (
    <div className={`cpSourcingMobileRoot ${css.toolbar}`}>
      <div className={css.searchWrap}>
        <TextField
          fullWidth
          size="small"
          placeholder={searchPlaceholder}
          value={searchValue}
          onChange={(e) => onSearchChange(e.target.value)}
          sx={SEARCH_SX}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ fontSize: 20, color: "#98a2b3" }} />
              </InputAdornment>
            ),
          }}
        />
      </div>
      <button
        type="button"
        className={css.iconButton}
        aria-label="Filters"
        onClick={onOpenFilters}
      >
        <TuneIcon sx={{ fontSize: 20 }} />
        {filterCount > 0 && <span className={css.filterCount}>{filterCount}</span>}
      </button>
    </div>
  );
}
